import shared from "../../data/js/shared";

const {
	gotoLoginLabel,
	gotoSignupLabel,
	loginLink,
	signupLink,
	privacyLink,
	gotoPrivacy,
	tryAgainLabel,
} = shared.login;

export interface LoginNavigationProps {
	loginView: string;
}

/**
 * LoginNavigation Component
 *
 * Renders navigation links at the bottom of the login form
 * Shows different links based on current login view state
 *
 * @param loginView - Current login view state
 */
export const LoginNavigation = (_props: LoginNavigationProps) => {
	return (
		<>
			<div className="already goto-login">
				<span>{gotoLoginLabel}</span>&nbsp;
				<a href="#login" className="to-login-link">
					{loginLink}
				</a>
			</div>
			<div className="already goto-otp">
				<a href="#login-otp" className="to-otp-link greenButton">
					{tryAgainLabel}
				</a>
			</div>
			<div className="already goto-otp2">
				<a href="#otp" className="to-otp2-link greenButton">
					{tryAgainLabel}
				</a>
			</div>
			<div className="already goto-signup">
				<span>{gotoSignupLabel}</span>&nbsp;
				<a href="#login" className="to-signup-link">
					{signupLink}
				</a>
			</div>
			<div className="already goto-privacy">
				<span>{gotoPrivacy}</span>&nbsp;
				<a
					href="/privacy-policy"
					target="_blank"
					className="to-privacy-link"
					rel="noopener noreferrer"
				>
					{privacyLink}
				</a>
			</div>
		</>
	);
};
